import React from 'react'
import { Columns, Element } from 'react-bulma-components'
import { OptimizedImage } from '../../components/optimized-image'

interface ComparisonPairProps {
  /** Optimized asset base name showing a compliant part */
  okImageName: string
  /** Optimized asset base name showing a defective part */
  nokImageName: string
  /** Accessible description of the compliant image */
  okAlt: string
  /** Accessible description of the defective image */
  nokAlt: string
}

/**
 * Side-by-side "this is fine / this is not" reference images.
 *
 * The supplied photographs already carry burnt-in OK / NOK labels, arrows and
 * circles around the rivet, so no overlay marker or caption is added: it would
 * duplicate what the image says, and the brief captions these only in French
 * with no matching row in the translations sheet. The coloured top rule is the
 * only styling, giving the pair a scannable structure without competing with
 * the artwork. The distinction is carried in the alt text for screen readers.
 */
export const ComparisonPair: React.FC<ComparisonPairProps> = ({
  okImageName,
  nokImageName,
  okAlt,
  nokAlt,
}) => (
  <Columns className="simond-comparison" mb={5} data-testid="comparison-pair">
    {[
      { imageName: okImageName, alt: okAlt, ok: true },
      { imageName: nokImageName, alt: nokAlt, ok: false },
    ].map(({ imageName, alt, ok }) => (
      <Columns.Column key={imageName} size={6} mobile={{ size: 12 }}>
        <Element
          className={`simond-comparison__item simond-comparison__item--${ok ? 'ok' : 'nok'}`}
          data-testid="comparison-item"
          data-state={ok ? 'ok' : 'nok'}
        >
          <OptimizedImage imageName={imageName} alt={alt} />
        </Element>
      </Columns.Column>
    ))}
  </Columns>
)

export default ComparisonPair
